import React, {
  useEffect, useCallback, useState,
} from 'react';
import { withTheme } from 'styled-components';
import Flexor from '../Flexor';
import CenteredRow from '../CenteredRow';
import Input from '../Input';
import Button from '../Button';
import { CCSeparator, Container } from './styled';

function CardConnect({
  submit: _submit, onToken = () => { }, next,
  firstName: _firstName, lastName: _lastName,
}) {
  const [ccToken, setCcToken] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [cvc, setCvc] = useState(null);
  const [firstName, setFirstName] = useState(_firstName);
  const [lastName, setLastName] = useState(_lastName);
  const submit = useCallback(() => {
    _submit({
      ccToken,
      firstName,
      lastName,
      month,
      year,
      cvc,
      processorType: 'card_connect',
      paymentType: 'cc',
    });
  }, [_submit, ccToken, cvc, firstName, lastName, month, year]);

  useEffect(() => {
    window.addEventListener('message', updateToken, false);
    return () => {
      window.removeEventListener('message', updateToken);
    };
  }, [updateToken]);

  const updateToken = useCallback((event) => {
    var token;

    try {
      token = JSON.parse(event.data);
    } catch (e) {
      //
    }

    if (token && token.message) {
      setCcToken(token.message);
      onToken({
        token: token.message,
        paymentType: 'cc',
      });
    }

    if (token && token.validationError) {
      console.warn(token.validationError);
      setCcToken(null);
      onToken({
        token: null,
        paymentType: 'cc',
      });
    }
  }, [onToken]);

  if (typeof window === 'undefined') {
    return <div />;
  }
  return (
    <Container onSubmit={submit} as="form">
      <iframe
        data-cy="credit-card-tokenizer"
        src={encodeURI(`https://fts.cardconnect.com:${process.env.GATSBY_GATEWAY_PORT}/itoke/ajax-tokenizer.html?invalidinputevent=true&fullmobilekeyboard=false&cardnumbernumericonly=true&tokenizewheninactive=true&formatinput=true&autofocus=true&placeholder=Credit Card Number&css=body{margin: 0;} form{height:50px; background-color: rgb(242,242,242); display: flex;justify-content: center; align-items: flex-end;border-radius: 2px;position: relative;} input{background-color:transparent; border:none; -webkit-appearance: none; padding: 0; outline: none; position: absolute; top: 10px; font-size: 16px;color: black;line-height: 24px;font-family: 'Public Sans', sans-serif;;margin: 0px 20px;}`)}
        frameBorder="0"
        scrolling="no"
        width="335px"
        height="50px"
      />
      <Flexor flex="0 1 20px" />
      <CenteredRow style={{ width: 335 }}>
        <Input
          name="cc-exp-month"
          type="tel"
          max={2}
          required
          value={month}
          update={setMonth}
          label="MM"
          style={{ flex: 0.5 }} />
        <CCSeparator />
        <Input
          name="cc-exp-year"
          type="tel"
          max={2}
          required
          value={year}
          update={setYear}
          label="YY"
          style={{ flex: 0.5 }} />
        <Input
          name="cc-csc"
          type="tel"
          max={4}
          required
          value={cvc}
          update={setCvc}
          label="CVC"
          style={{ flex: 1, marginLeft: 20 }} />
      </CenteredRow>
      <Flexor flex="0 1 20px" />
      <CenteredRow style={{ width: 335 }}>
        <Input
          required
          value={firstName}
          update={setFirstName}
          label="First Name"
          style={{ marginRight: 20 }} />
        <Input
          required
          value={lastName}
          update={setLastName}
          label="Last Name" />
      </CenteredRow>
      {
        next ? next() : (
          <>
            <Flexor flex="0 0 20px" />
            <Button submit label="Submit" />
          </>
        )
      }
    </Container>
  );
}

export default withTheme(CardConnect);